import { AppModal } from 'shared/UI/UIKit/Modal';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { createMunicipalityAction } from 'features/municipalities/redux/actions';
import type { CreateMunicipalityModalProps, MunicipalityFormValues } from './types';
import { MunicipalityModalFooter } from '../ModalFooter';
import { MunicipalityForm } from '../../Form/Municipality';
import { useRegions } from '../../Form/Municipality/use-regions';

export const CreateMunicipalityModal = (props: CreateMunicipalityModalProps) => {
  const [form] = useAppForm<MunicipalityFormValues>();

  const { regions, loading } = useRegions();
  const dispatch = useAppDispatch();

  const hideModal = () => {
    form.resetFields();
    props.hide();
  };

  const onSubmit = () => {
    form.validateFields().then((values) => {
      dispatch(
        createMunicipalityAction({
          name: values.name,
          regionId: values.regionId,
        }),
      )
        .unwrap()
        .then(() => {
          hideModal();
        });
    });
  };

  const footer = (
    <MunicipalityModalFooter hideModal={hideModal} onSubmit={onSubmit} title="Сохранить" />
  );
  const content = <MunicipalityForm form={form} regionOptions={regions} regionsLoading={loading} />;

  return (
    <AppModal
      visible={props.visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Создать муниципалитет"
      maskClosable={false}
    />
  );
};
